import React, { useMemo } from 'react';
import { View, Text, StyleSheet } from '@react-pdf/renderer';
import { useTemplateColors } from 'PDF/TemplateEngine/TemplateColorsContext';

// Footer hardcoded legacy. Se monta desde TemplateRenderer cuando el template
// NO tiene una section con type='footer' en sections[]. Templates que quieren
// customización completa deben agregar una section type='footer' con config
// — ver FooterSection.jsx.
function LegacyFooterSection({ config }) {
  const { colors, FONT } = useTemplateColors();
  const styles = useMemo(
    () =>
      StyleSheet.create({
        footer: {
          position: 'absolute',
          bottom: '0.8cm',
          left: '1.5cm',
          right: '1.5cm',
          borderTop: `1px solid ${colors.border}`,
          paddingTop: '0.2cm',
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center',
        },
        text: {
          fontSize: 8,
          fontFamily: FONT.base,
          color: colors.muted,
        },
        center: {
          flex: 1,
          textAlign: 'center',
        },
      }),
    [colors, FONT]
  );

  const left = [config?.telefonos, config?.correo].filter(Boolean).join(' · ');
  const right = [config?.direccion, config?.ciudad].filter(Boolean).join(', ');

  return (
    <View style={styles.footer} fixed>
      <Text style={styles.text}>{left}</Text>
      <Text
        style={[styles.text, styles.center]}
        render={({ pageNumber, totalPages }) => `Página ${pageNumber} de ${totalPages}`}
      />
      <Text style={styles.text}>{right}</Text>
    </View>
  );
}

export default LegacyFooterSection;
